import { render, staticRenderFns } from "./TalentManagerWrapper.vue?vue&type=template&id=ff7b4df2&scoped=true&"
import script from "./TalentManagerWrapper.vue?vue&type=script&lang=ts&"
export * from "./TalentManagerWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./TalentManagerWrapper.vue?vue&type=style&index=0&id=ff7b4df2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7b4df2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
